import { render } from "./ProductStories.vue?vue&type=template&id=a4035d24"
import script from "./ProductStories.vue?vue&type=script&lang=js"
export * from "./ProductStories.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__